import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';
import partnerPropTypes from '../../../partnerPropTypes';

const createStatus = name =>
    `${name} har avslått avtalen. Om dere blir enige om en ny avtale, kan du starte Trygg betaling på nytt.`;

const AgreementAccepted = ({ partner }) => (
    <StatusSummaryButton
        href="/start-trygg-betaling"
        statusSummary={createStatus(partner.name)}
        actionRequiredType="NEGATIVE"
    >
        Send nytt avtaleforslag
    </StatusSummaryButton>
);

AgreementAccepted.propTypes = {
    partner: partnerPropTypes.isRequired,
};

export default AgreementAccepted;



// WEBPACK FOOTER //
// ./safeTrade/buyer/agreement/summaries/agreementRejectedSummary.jsx